/**
 * Replaces `{name}` placeholders in a template with values from `params`.
 * Mirrors the legacy UWM `stringUtils.formatByName`.
 */
export const formatByName = (template: string, params?: Record<string, unknown>): string => {
    if (!template) return template ?? '';

    return template.replace(/\{\{|\}\}|\{(\w+)\}/g, (m, n: string | undefined) => {
        if (m === '{{') return '{';
        if (m === '}}') return '}';
        const value = n != null ? params?.[n] : undefined;
        return value == null ? m : String(value);
    });
};

/**
 * Replaces positional `{0}`, `{1}`, … placeholders in a string with provided values.
 */
export function formatString(input: string | undefined | null, ...values: Array<string | number>): string {
    if (!input) return '';

    let result = input;
    for (let index = 0; index < values.length; index++) {
        result = result.replace(`{${index}}`, String(values[index]));
    }
    return result;
}

export default {formatByName, formatString};
